<script setup lang="ts">
const props = defineProps<{
  imgSrc: ImgixImagePath;
  name: string;
}>();

const { buildImgixURL } = useImgixURL();
const src = computed(() => buildImgixURL(props.imgSrc));
</script>

<template>
  <img :src="src" :alt="name" />
</template>
